import { FC, useEffect, useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export const ZBComp: FC = () => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');
    const [lineAni, setLineAni] = useState('');

    useEffect(() => {
        AniContainer.create({
            triggerElement: `.${css.ZBComp} .progress-box`,
            triggerHook: 1,
            offset: '10%',
            onEnter() {
                setLineAni('line-inner-ani');
            },
            onLeave() {
                setLineAni('');
            },
        });
    }, []);

    return (
        <div className={`${css.ZBComp} d2x-ZB GtmModuleData-section`} data-section-id={css.ZBComp} data-section-title={t('sec11_title')}>
            <div className="sticky">
                <div className="desc-box">
                    <div className="desc-box-left">
                        <div className="desc">{t('sec11_title')}</div>
                        <div className="title">{t('sec11_subtitle')}</div>
                    </div>
                    <div className="desc-box-right">{t('sec11_desc')}</div>
                </div>
                <div className="img-box-wrapper">
                    {locale === 'au' ? (
                        <NextImage src={require('@publicLocal/delta2max/teaser/pc/eu/au_3.jpg')} alt={t('sec11_subtitle')} aria-label={t('sec11_subtitle')} />
                    ) : (
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/10.webp')}
                            src={require('@publicLocal/delta2max/teaser/pc/eu/10.jpg')}
                            alt={t('sec11_subtitle')}
                            aria-label={t('sec11_subtitle')}
                        />
                    )}
                </div>
                <div className="desc-box-2">
                    <div className="desc-box-2-left">
                        {t.rich('zb_solar_input', {
                            title: (text: string) => <div className="title-text">{text}</div>,
                        })}
                    </div>
                    <div className="desc-box-2-right">{t('sec11_desc2')}</div>
                </div>
                <div className="data-box">
                    <div className="data-box-left">
                        <div className="title">{t('sec11_charge_time')}</div>
                        <div className="content-box">
                            <div className="content-list">
                                {t.rich('sec11_1000w', {
                                    big: (text: string) => <span className="big-text">{text}</span>,
                                })}
                            </div>
                            <div className="content-list">
                                {t.rich('sec11_880w', {
                                    big: (text: string) => <span className="big-text">{text}</span>,
                                })}
                            </div>
                            <div className="content-list">
                                {t.rich('sec11_800w', {
                                    big: (text: string) => <span className="big-text">{text}</span>,
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="data-box-right">
                        <div className="title">{t('title_mppt')}</div>
                        <div className="progress-box">
                            <div className="progress-1">
                                <div className="line">
                                    <div className={`line-inner ${lineAni}`}></div>
                                </div>
                                <div className="line-text">{t('sec11_num1')}</div>
                            </div>
                            <div className="progress-1-desc">{t('sec11_ps')}</div>
                            <div className="progress-2">
                                <div className="line">
                                    <div className={`line-inner ${lineAni}`}></div>
                                </div>
                                <div className="line-text">{t('sec11_num2')}</div>
                            </div>
                            <div className="progress-2-desc">{t('sec11_other')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
